import React, { createContext, useReducer, useEffect } from "react";
import { encryptText } from "commonmethods/Encryption.js";
import { initGuestCartDB, getAllGuestCartItems } from "utils/guestCartDB.js";

export const AuthContext = createContext();

export const reducer = (state, action) => {
  switch (action.type) {
    case "LOGIN":
      // console.log("🔐 AUTH REDUCER: LOGIN action received", {
      //   user: action.payload.user,
      //   userId: action.payload.user?.User_Id,
      //   permissions: action.payload.permissions,
      //   token: action.payload.token
      // });

      var cipherUser = encryptText(JSON.stringify(action.payload.user));
      localStorage.setItem("user", cipherUser);
      var cipheraccess = encryptText(
        JSON.stringify(action.payload.permissions)
      );
      localStorage.setItem("permissions", cipheraccess);
      localStorage.setItem("token", action.payload.token);

      const newState = {
        ...state,
        isAuthenticated: true,
        user: action.payload.user,
        permissions: action.payload.permissions,
        token: action.payload.token,
      };

      // console.log("✅ AUTH REDUCER: New state after LOGIN", {
      //   isAuthenticated: newState.isAuthenticated,
      //   user: newState.user,
      //   userId: newState.user?.User_Id
      // });

      return newState;
    case "LOGOUT":
      localStorage.removeItem("user");
      localStorage.removeItem("permissions");
      localStorage.removeItem("token");
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        permissions: null,
        token: null,
      };
    case "SETBRAND":
      var cipherCompany = encryptText(
        JSON.stringify(action.payload.companyInfo)
      );
      localStorage.setItem("companyInfo", cipherCompany);
      return {
        ...state,
        companyInfo: action.payload.companyInfo,
      };
    case "CLEARBRAND":
      localStorage.removeItem("companyInfo");
      return {
        ...state,
        companyInfo: null,
      };
    case "SETSETTINGS":
      var cipherSettings = encryptText(
        JSON.stringify(action.payload.appSettings)
      );
      localStorage.setItem("appSettings", cipherSettings);
      return {
        ...state,
        appSettings: action.payload.appSettings,
      };
    case "CLEARSETTINGS":
      localStorage.removeItem("appSettings");
      return {
        ...state,
        appSettings: null,
      };
    case "LOAD_GUEST_CART":
      return {
        ...state,
        guestCart: action.payload.items || [],
        guestCartCount: action.payload.count || 0,
      };
    case "ADD_GUEST_ITEM":
      const updatedCartAdd = [...(state.guestCart || []), action.payload];
      return {
        ...state,
        guestCart: updatedCartAdd,
        guestCartCount: updatedCartAdd.length,
      };
    case "UPDATE_GUEST_ITEM":
      const updatedCartUpdate = (state.guestCart || []).map((item) =>
        item.id === action.payload.id
          ? {
              ...item,
              quantity: action.payload.quantity,
              Modified_On: new Date().toISOString(),
            }
          : item
      );
      return {
        ...state,
        guestCart: updatedCartUpdate,
        guestCartCount: updatedCartUpdate.length,
      };
    case "REMOVE_GUEST_ITEM":
      const updatedCartRemove = (state.guestCart || []).filter(
        (item) => item.id !== action.payload
      );
      return {
        ...state,
        guestCart: updatedCartRemove,
        guestCartCount: updatedCartRemove.length,
      };
    case "CLEAR_GUEST_CART":
      return {
        ...state,
        guestCart: [],
        guestCartCount: 0,
      };
    case "UPDATE_GUEST_CART_COUNT":
      return {
        ...state,
        guestCartCount: action.payload,
      };
    case "UPDATE_GUEST_CART_ITEM":
      // Update a specific guest cart item (for save for later, etc.)
      return {
        ...state,
        guestCart: state.guestCart.map((item) =>
          item.id === action.payload.id
            ? { ...item, ...action.payload.updates }
            : item
        ),
      };
    case "REFRESH_CART":
      // Trigger cart refresh in components listening to this flag
      return {
        ...state,
        refreshCart: true,
      };
    case "RESET_REFRESH_CART":
      // Reset the refresh cart flag
      return {
        ...state,
        refreshCart: false,
      };
    default:
      localStorage.removeItem("user");
      localStorage.removeItem("permissions");
      localStorage.removeItem("companyInfo");
      localStorage.removeItem("token");
      localStorage.removeItem("appSettings");
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        permissions: null,
        companyInfo: null,
        token: null,
        appSettings: null,
      };
  }
};

// Initial state for authentication context
export const initialState = {
  isAuthenticated: false,
  user: null,
  permissions: null,
  companyInfo: null,
  token: null,
  appSettings: null,
  guestCart: [],
  guestCartCount: 0,
};

// AuthProvider component to wrap the app
export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <AuthContext.Provider value={{ state, dispatch }}>
      {children}
    </AuthContext.Provider>
  );
};
